const routeConstants = {
  LOGIN: 'login',
  SIGNUP: 'signup',
  NOTFOUND: 'notfound',
  AUTH: 'auth',
  BABY: 'baby',
  BABYNAMES: 'baby/names',
  BABYTOPICS: 'baby/topics/:params',
  BABYBLOG: 'blog/:article_id',
  WEEKBYWEEK:"week-by-week/:week_id",
  DASHBOARD: '',
  USER: 'user',
  BABY_REGISTRY_CHECKLIST: 'baby/registry-checklist',
  REGISTRY_BUILDER: 'baby/registry-builder',
  GROWTH_TRACKER: 'baby/growth-tracker',
  PREGNANCY: 'pregnancy',
  NEW_PASSWORD: 'newpassword',
  PARENTHOOD: 'parenthood',
  COMMUNITY: 'community',
  COMMUNITY_BLOG: 'community/post/:post_id',
  BIRTH_CLUB: 'community/discover/:params',
  BABYACTIVITIES: 'parenthood/babyactivities',
  LULLABIES: 'parenthood/lullabies',
  FEEDING: 'parenthood/feeding',
  BABYDEVELOPMENT: 'parenthood/babydevelopment',
  FAMILY: 'family',
  FERTILITY: 'family/fertility',
  HEALTH: 'family/health',
  OVULATIONTRACKER: 'family/ovulationtracker',
  WEEKWISEPREGNANCY: 'pregnancy/weekwisepregnancy',
  FETALDEVELOPMENT: 'pregnancy/fetaldevelopment',
  TIPSFORPREGNANCY: 'pregnancy/tipsforpregnancy',
  ONLINEBIRTHCLASS: 'pregnancy/onlinebirthclass',
  DUEDATECALCULATOR: 'pregnancy/duedatecalculator',
  // COURSES: 'courses',
  // COURSEDETAIL: 'courses/:courseId',
  // VIEWCOURSE: 'courses/view/:courseId',
  // MYCOURSES: 'courses/mycourses',
  SETTING: 'setting',
  CONTACTUS: 'contactus',
  REPORT: 'report/:type/:id',
  ABOUTUS: 'aboutus',
  // COURSESINFO: 'courses/coursesinfo',
  PRIVACYPOLICY: 'privacypolicy',
  SEARCH: 'search',
  OVULATIONTRACK: 'family/ovulationtracker/Tracker',
  BIRTHCLUB: 'community/:group_id',
  PAYMENT: '/payment',
  TERMS_OF_USE: 'termsofuse',
  MOBILE_APP: 'mobileapp',
  CREATE_GROUP: 'creategroup',
  GROUP_DETAIL: 'groupdetail',
  ARTICLES_TOPICS: '/:type/blog/:lowercase_name',
  SAVED_NAMES: '/baby/names/savednames',
  BLOGS: '/blogs',
  TOPIC_BLOG: '/blogs/:blog_id',
  DEACTIVE_ACCOUNT: 'deactive-account',
};

export default routeConstants;
